/**
 * A mapping of key to endpoint.
 * @type {Object}
 */
const FUNCTIONS_ENDPOINT = {
  GET_PROMO_CODES: '/functions/get-promo-codes',
  RESET_PASSWORD: '/functions/reset-password',
  CHANGE_PASSWORD: '/functions/change-password',
  VERIFY_EMAIL: '/functions/verify-email'
}

export {
  FUNCTIONS_ENDPOINT
}
